import { useAppDispatch, useAppSelector } from 'app/state'
import { setLastProcessingJobDone } from 'features/jobs/state/jobsProcessingSlice'
import { JobStatusType } from 'features/jobs/types'
import { Snackbar } from '@carto/meridian-ds/components'

// TODO: Temp. Notification component, useful until notifications menu was implemented.
// If we want to use this kind of notifications too, we should add `notistack`
// https://material-ui.com/components/snackbars/#complementary-projects
// https://iamhosseindhv.com/notistack/demos
function JobNotification() {
  const dispatch = useAppDispatch()
  const lastProcessingJobDone = useAppSelector((state) => state.jobs.lastProcessingJobDone)
  const showNotification = !!lastProcessingJobDone
  const severity = lastProcessingJobDone?.status?.status === JobStatusType.Failure ? 'error' : 'success'

  return (
    <Snackbar
      open={showNotification}
      onClose={() => dispatch(setLastProcessingJobDone())}
      severity={severity}
      title={lastProcessingJobDone?.connection}
    >
      {lastProcessingJobDone?.status?.status}
    </Snackbar>
  )
}

export default JobNotification
